module.exports = __webpack_public_path__ + "img/u2850.066662da.png";